/**
 * Terms of Service — static page for the seeded Navarasam reunion site.
 */

import { Link } from 'react-router';

export function TermsPage() {
  return (
    <article className="container mx-auto px-4 py-16 max-w-3xl">
      <h1 className="text-4xl font-display font-bold text-white mb-3">Terms of Service</h1>
      <p className="text-white/40 text-sm mb-10">Last updated 2026-05-13</p>

      <section className="prose prose-invert max-w-none">
        <p>
          Welcome to Re:Nav-96. By creating an account or accepting an invitation, you
          agree to the rules below. They exist to keep the community kind and the site
          usable; nothing here is a substitute for legal advice.
        </p>

        <h2>Membership</h2>
        <ul>
          <li>This is a private site for Navarasam School Class of 1996 alumni, their immediate family, and explicit guests of the chapter/branch admins.</li>
          <li>Membership is by invitation or admin approval. Self-signup creates an unverified account with no scope memberships until an admin grants access.</li>
          <li>Admins may revoke access at any time for behaviour that harms the community.</li>
        </ul>

        <h2>Acceptable use</h2>
        <ul>
          <li>Be kind. Don't post content that harasses, threatens, or impersonates other people.</li>
          <li>Photos: only upload pictures you have the right to share. Don't upload pictures of minors without consent from their parent/guardian.</li>
          <li>No commercial advertising, scraping, or off-topic spam. Volunteer fundraising for class-organised charity is welcome.</li>
        </ul>

        <h2>Content ownership</h2>
        <p>
          You own what you post. By posting, you grant the site a limited licence to
          store, display, and redistribute your content within this community (including
          through share links the admin generates). You can remove your content from{' '}
          <Link to="/member/settings" className="link">Settings</Link>; remnants in
          server backups are purged within 30 days.
        </p>

        <h2>Service availability</h2>
        <p>
          The site is provided as-is by a volunteer team. We aim to keep it running but
          don't promise uptime or guarantee that data won't ever be lost. Don't rely on
          this site as your only copy of family photos.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these terms; material changes will be announced via email and
          on the home page. Continued use after a change means you accept the new terms.
        </p>

        <h2>Contact</h2>
        <p>
          Questions? <Link to="/contact" className="link">Get in touch</Link>.
        </p>
      </section>
    </article>
  );
}

export default TermsPage;
